export const MANUFACTURER_PERMISSION = {
  VIEW: 'MD_MANUFACTURER_VIEW',
  ADD: 'MD_MANUFACTURER_ADD',
  EDIT: 'MD_MANUFACTURER_EDIT',
  DEL: 'MD_MANUFACTURER_DEL',
}
